import type { UserConfig } from '@/entities/user-config';
import { updateUserConfig } from '@/entities/user-config';

import type { Conversation, PersistedMessage } from '../types/chat.types';

const MAX_HISTORY = 10;

export const deriveConversationName = (messages: PersistedMessage[]) => {
  const firstHuman = messages.find(m => m.sender === 'human');
  const firstTextPart = firstHuman?.parts.find(p => p.type === 'text');
  const text = (firstTextPart?.content ?? '').trim();
  return text || '...';
};

interface SaveUserHistoryParams {
  userConfig: UserConfig;
  saveUser: (config: UserConfig) => void;
  updatedConversation: Conversation;
  existing: Conversation[];
  idx: number;
}

export default function saveUserHistory({
  userConfig,
  saveUser,
  updatedConversation,
  existing,
  idx
}: SaveUserHistoryParams) {
  const ensuredName =
    updatedConversation.name || deriveConversationName(updatedConversation.messages);

  const withName: Conversation = { ...updatedConversation, name: ensuredName };

  const chatHistory =
    idx >= 0
      ? [...existing.slice(0, idx), withName, ...existing.slice(idx + 1)]
      : [withName, ...existing];
  const limited = chatHistory.slice(0, MAX_HISTORY);
  saveUser(updateUserConfig(userConfig, { chatHistory: limited }));
}
